// extracted by mini-css-extract-plugin
module.exports = {"cards":"Cta_cards__GeRLF","card":"Cta_card__2F81Q","img":"Cta_img__3koAh","btn":"Cta_btn__1s_n1"};